import { createContext, PropsWithChildren, useContext } from "react";
import { MenuTree } from "@shared/routing";

const RoutingTreeContext = createContext<{ nav: MenuTree } | undefined>(undefined);

export const useRoutingTreeContext = () => {
  const ctx = useContext(RoutingTreeContext);
  if (!ctx) throw new Error("useRoutingTreeContext must be used within a RoutingTreeProvider");
  return ctx;
}

export const RoutingTreeProvider = ({ menu, children }: PropsWithChildren<{ menu: any }>) => {
  return (
    <RoutingTreeContext value={{ nav: menu }}>
      {children}
    </RoutingTreeContext>);
}
